import * as Sentry from '@sentry/react';

const pushServerPublicKey = import.meta.env.VITE_VAPID_PUBLIC_KEY

function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

const useWebPush = (postUrl) => {
    const request = () => {
        if ('serviceWorker' in navigator && 'PushManager' in window) {
            navigator
                .serviceWorker
                .register('/service-worker.js')
                .then(swReg => {
                    console.log('Service Worker Registered', swReg);
                })
                .catch(error => {
                    Sentry.captureException(error);
                    console.error('Service Worker Register Error', error);
                });

            navigator
                .serviceWorker
                .ready
                .then(swReg => {
                        console.log('service worker ready');
                        return swReg.pushManager.getSubscription()
                            .then(subscription => {
                                if (subscription === null) {
                                    const applicationServerKey = urlBase64ToUint8Array(pushServerPublicKey);
                                    return swReg.pushManager.subscribe({
                                        userVisibleOnly: true,
                                        applicationServerKey: applicationServerKey
                                    });
                                } else {
                                    return subscription;
                                }
                            });
                    }
                )
                .then(subscription => {
                    if (!localStorage.getItem('has_pushed')){
                        return axios.post(postUrl, subscription).then(() => localStorage.setItem('has_pushed', '1'))
                    }
                    return true;
                }).catch(error => {
                console.error('Service Worker Error', error);
                if (error.code !== 0) {
                    Sentry.captureException(error);
                }
            })
        }
    }

    return {
        request: request
    }
}
export {useWebPush}
